/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "eye-view-5f7b458b--sprite",
  "use": "eye-view-5f7b458b--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"eye-view-5f7b458b--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(23.386 -765.258)\"><path d=\"M-4.911,790.457a17.789,17.789,0,0,1-5.672-.931,17.29,17.29,0,0,1-6.861-4.505l-.1-.109a2.962,2.962,0,0,1-.009-4.116,17.567,17.567,0,0,1,8.035-4.925,17.735,17.735,0,0,1,10.3.318,17.261,17.261,0,0,1,6.862,4.5l.1.105a2.964,2.964,0,0,1,.01,4.119,17.552,17.552,0,0,1-8.034,4.925A17.789,17.789,0,0,1-4.911,790.457Zm.013-13.2A15.765,15.765,0,0,0-9,777.8a15.558,15.558,0,0,0-7.109,4.376.97.97,0,0,0,0,1.346l.106.11a15.31,15.31,0,0,0,6.061,4,15.722,15.722,0,0,0,9.137.28A15.557,15.557,0,0,0,6.3,783.534a.969.969,0,0,0,0-1.345l-.1-.105a15.318,15.318,0,0,0-6.065-4A15.784,15.784,0,0,0-4.9,777.257Z\" fill=\"currentColor\" /><path d=\"M-4.9,787.524a4.672,4.672,0,0,1-4.667-4.667A4.671,4.671,0,0,1-4.9,778.191a4.67,4.67,0,0,1,4.666,4.666A4.672,4.672,0,0,1-4.9,787.524Zm0-7.333a2.669,2.669,0,0,0-2.667,2.666A2.67,2.67,0,0,0-4.9,785.524a2.67,2.67,0,0,0,2.666-2.667A2.669,2.669,0,0,0-4.9,780.191Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
